import React from 'react';
import Messages from './Messages.js'
import { useState, useEffect } from "react"
import axios from 'axios'
 

function runScript(code) {
  axios.post('http://127.0.0.1:5000/sk', {input: code}).then((response) => {let result = response.data;
  console.log(result);
  return result;
},
(error) => {
  console.log(error);
  return error;
})
}

function ChatApp() {
  const [userInput, setUserInput] = useState('');
  const [chatLog, setChatLog] = useState([]);

  const handleChange = (e) => {
    setUserInput(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (userInput.trim() !== '') {
      setChatLog([...chatLog, { message: runScript(userInput), type: 'user'}]);
      setChatLog([...chatLog, { message: userInput, type: 'user' }]);
      
      setUserInput('');
    }
  };

  return (
    <div className="chat-app">
      <div className="chat-log">
        {chatLog.map((entry, index) => (
          <div key={index} className={`chat-entry ${entry.type}`}>
            {entry.message}
          </div>
        ))}
      </div>
      <form onSubmit={handleSubmit} className="chat-input">
        <input
          type="text"
          placeholder="Type your message..."
          value={userInput}
          onChange={handleChange}
        />
        <button type="submit">Send</button>
      </form>
    </div>
  );
}

export default ChatApp;
